import React, { useEffect, useState } from 'react';
import { Input, Tooltip } from 'antd';
import { EditOutlined, SaveOutlined } from '@ant-design/icons';

interface EditableTextProps {
  value: string;
  id?: string;
  inputType?: string | undefined;
  onSave: (newText: string) => boolean;
}

const EditableText: React.FC<EditableTextProps> = ({
  value,
  id,
  inputType,
  onSave,
}) => {
  const [text, setText] = useState(value);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setText(value);
  }, [value]);

  const handleSave = () => {
    if (!onSave(text)) setText(value);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <Input
        id={id && `${id}-input`}
        value={text}
        type={inputType}
        onChange={(e) => setText(e.target.value)}
        style={{
          width: 120,
          marginBottom: '0px',
          padding: '0px',
          paddingLeft: '5px',
          paddingRight: '5px',
          margin: '0px',
        }}
        suffix={
          <Tooltip title="Save">
            <SaveOutlined
              id={id && `${id}-save`}
              onClick={handleSave}
              style={{ cursor: 'pointer', color: 'rgba(0,0,0,.45)' }}
            />
          </Tooltip>
        }
        onPressEnter={handleSave}
        autoFocus
      />
    );
  }

  return (
    <span
      id={id && `${id}-label`}
      style={{
        cursor: 'pointer',
        display: 'inline-flex',
        paddingBottom: 2,
        lineHeight: '1.5',
        fontWeight: 500,
        textDecoration: 'underline',
        textUnderlineOffset: '4px',
        textDecorationStyle: 'dotted',
        textDecorationThickness: 'px',
      }}
      onClick={() => setIsEditing(true)}
    >
      <Tooltip title="Click to edit">{text}</Tooltip>
    </span>
    // <EditOutlined style={{ color: 'rgba(0,0,0,.45)', marginLeft: 4 }} />
  );
};

export default EditableText;
